export const TRANSFER_SEARCH_EMPTY_STATE_WITH_NUMBER_DESCRIPTION =
  'No results found,\nYou can transfer to this exact number,\nor try to search again';

export const TRANSFER_SEARCH_EMPTY_STATE_DESCRIPTION =
  'No results found,\nPlease try another search';
